import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const Text = ({ idCountry, classes }) => {
  if (idCountry === 'COL') {
    return (
      <p className={classes.message}>
        Tu tienda ya se encuentra lista para que empieces a realizar ventas.
      </p>
    );
  }

  return (
    <p className={classes.message}>
      Tu tienda ya esta lista para que empieces a realizar ventas, te dejamos la{' '}
      <Link className={classes.link} to="/tutoriales">
        sección de tutoriales
      </Link>{' '}
      para que te ayude en tus proximos pasos.
    </p>
  );
};

const MessageStepsDoneText = ({ classes }) => {
  const idCountry =
    useSelector((state) => state.tienda.Country_idCountry) || 'ARG';

  return (
    <div className={classes.container_message}>
      <Text idCountry={idCountry} classes={classes} />
    </div>
  );
};

export default MessageStepsDoneText;
